var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "6" } }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.$t("Asiakkaan tiedot")))
                ]),
                _vm._v(" "),
                _vm.contractsSelected
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-10",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "label",
                              { staticClass: "font-weight-bold pt-0" },
                              [_vm._v(_vm._s(_vm.$t("Yrityksen nimi")))]
                            ),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                type: "text",
                                value: _vm.contract.Company.CompanyName,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-10",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "label",
                              { staticClass: "font-weight-bold pt-0" },
                              [_vm._v(_vm._s(_vm.$t("Y-tunnus")))]
                            ),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                type: "text",
                                value: _vm.contract.Company.BusinessId,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "FirstName__contactperson-1",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-10",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Yhteyshenkilön etunimi"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    name: "FirstNameContactperson1"
                                  },
                                  on: {
                                    change: _vm.FirstNameContactperson1Changed
                                  },
                                  model: {
                                    value: _vm.FirstNameContactperson1,
                                    callback: function($$v) {
                                      _vm.FirstNameContactperson1 = $$v
                                    },
                                    expression: "FirstNameContactperson1"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "LastName__contactperson-1",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-10",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Yhteyshenkilön sukunimi"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    name: "LastNameContactperson1"
                                  },
                                  on: {
                                    change: _vm.LastNameContactperson1Changed
                                  },
                                  model: {
                                    value: _vm.LastNameContactperson1,
                                    callback: function($$v) {
                                      _vm.LastNameContactperson1 = $$v
                                    },
                                    expression: "LastNameContactperson1"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "Phone__contactperson-1",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-10",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Yhteyshenkilön puhelinnumero")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    name: "Phone__contactperson-1",
                                    maxlength: "50"
                                  },
                                  on: {
                                    change: _vm.PhoneNumberContactperson1Changed
                                  },
                                  model: {
                                    value: _vm.PhoneNumberContactperson1,
                                    callback: function($$v) {
                                      _vm.PhoneNumberContactperson1 = $$v
                                    },
                                    expression: "PhoneNumberContactperson1"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "Email__contactperson-1",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-10",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Yhteyshenkilön sähköpostiosoite"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    name: "Email__contactperson-1",
                                    maxlength: "100"
                                  },
                                  on: {
                                    change: _vm.EmailContactperson1Changed
                                  },
                                  model: {
                                    value: _vm.EmailContactperson1,
                                    callback: function($$v) {
                                      _vm.EmailContactperson1 = $$v
                                    },
                                    expression: "EmailContactperson1"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "CompanyPhone",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-10",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [_vm._v(_vm._s(_vm.$t("Puhelinnumero")))]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "CompanyPhone",
                                    value: _vm.contract.Company.Phone
                                      ? _vm.contract.Company.Phone
                                      : "+358"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "validated-form-group",
                          {
                            attrs: {
                              "validation-id": "CompanyEmail",
                              "validation-errors": _vm.validationErrors
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-10",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [_vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "CompanyEmail",
                                    value: _vm.contract.Company.Email
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "6" } }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(_vm.$t("Loppulaskun osoite")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("HUOM!")))]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "Jos sähköpostiosoite on annettu, loppulasku lähtee sinne vaikka paperilaskuosoite on annettu. Jos asiakkaalla on e-lasku tai suoramaksu, annetut loppulaskutiedot eivät vaihda laskutustapaa."
                              )
                            ) +
                            "\n                        "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "MoveOutStreetOnline",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-10",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold pt-0" },
                            [_vm._v(_vm._s(_vm.$t("Katuosoite")))]
                          ),
                          _vm._v(" "),
                          _c("street-autocomplete", {
                            attrs: {
                              "postal-filter": _vm.postal,
                              "zip-locale": _vm.mpZipLocale
                            },
                            on: {
                              "street-selected": _vm.meteringPointStreetSelected
                            },
                            model: {
                              value: _vm.mpStreetStr,
                              callback: function($$v) {
                                _vm.mpStreetStr = $$v
                              },
                              expression: "mpStreetStr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "MoveOutZipOnline",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-10",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold pt-0" },
                            [_vm._v(_vm._s(_vm.$t("Postinumero")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c("postal-autocomplete", {
                                    attrs: {
                                      "street-locale": _vm.mpStreetLocale,
                                      "post-office-target":
                                        "#move-out-address-place"
                                    },
                                    on: {
                                      "postal-code-selected":
                                        _vm.meteringPointPostalSelected
                                    },
                                    model: {
                                      value: _vm.postalStr,
                                      callback: function($$v) {
                                        _vm.postalStr = $$v
                                      },
                                      expression: "postalStr"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-col", [
                                _c("p", {
                                  staticClass: "form-control-static",
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: { id: "move-out-address-place" },
                                  domProps: {
                                    textContent: _vm._s(_vm.postOffice)
                                  }
                                })
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "MoveOutCONameOnline",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-10",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold pt-0" },
                            [_vm._v(_vm._s(_vm.$t("c/o Nimi")))]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value.mp",
                                modifiers: { mp: true }
                              }
                            ],
                            attrs: {
                              id: "move-out-address-coname",
                              value: _vm.coName,
                              name: "MoveOutCONameOnline",
                              maxlength: "100"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "validated-form-group",
                    {
                      attrs: {
                        "validation-id": "MoveOutEmail",
                        "validation-errors": _vm.validationErrors
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-10",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "font-weight-bold pt-0",
                              attrs: { for: "move-out-address-email" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value"
                              }
                            ],
                            attrs: {
                              id: "move-out-address-email",
                              type: "text",
                              name: "MoveOutEmail",
                              value:
                                _vm.contract.MoveOutProcess
                                  .FinalInvoicingAddress.Email
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }